module.exports = __webpack_public_path__ + "3b53094db09aa9fc13550ceee3f1d5bd.ttf";